import HRPersonelRequestService from "@/services/HRPersonelRequest.service";

const state = {
  personList: [],
  personByID: [],
  getAllList: [],
  cvlTypes: [],
  countries: [],
  usersWithPerms: [],
  distinctedPositions: [],
  passportsAll: [],
  passportsPDF: []
}

const mutations = {
  set_cvlTypes(state, payload) {
    state.cvlTypes = payload;
  },
  clear_cvlTypes(state) {
    state.cvlTypes = [];
  },
  set_countries(state, payload) {
    state.countries = payload;
  },
  clear_countries(state) {
    state.countries = [];
  },
  set_personByID(state, payload) {
    state.personByID = payload;
  },
  clear_personByID(state) {
    state.personByID = [];
  },
  set_allData(state, payload) {
    state.getAllList = payload;
  },
  clear_allData(state) {
    state.getAllList = [];
  },
  set_usersWithPerms(state, payload) {
    state.usersWithPerms = payload;
  },
  clear_usersWithPerms(state) {
    state.usersWithPerms = [];
  },
  set_distinctedPositions(state, payload) {
    state.distinctedPositions = payload;
  },
  clear_distinctedPositions(state) {
    state.distinctedPositions = [];
  },
  set_passportAll(state, payload) {
    state.passportsAll = payload;
  },
  clear_passportAll(state) {
    state.passportsAll = [];
  },
  set_passportPDF(state, payload) {
    state.passportsPDF = payload;
  },
  clear_passportPDF(state) {
    state.passportsPDF = [];
  },

}
const actions = {
  async getAllAndGetByMail({ commit }, payload) {
    await commit("clear_allData");
    const all = await HRPersonelRequestService.getAllAndGetByMailByMailService(payload);
    await commit("set_allData", all);
    return all.data;
  },

  async getPersonByID({ commit }, payload) {
    await commit("clear_personByID");
    const person = await HRPersonelRequestService.getHRPersonelByIdService(payload);
    await commit("set_personByID");
    return person.data;
  },

  async getUsersWithPerms({ commit }, payload) {
    await commit("clear_usersWithPerms");
    const perm = await HRPersonelRequestService.getUsersWithPerms(payload);
    await commit("set_usersWithPerms");
    return perm.data;
  },

  async passportsAll({ commit }, payload) {
    await commit("clear_passportAll");
    const pass = await HRPersonelRequestService.getPersonelPassportReport(payload);
    await commit("set_passportAll");
    return pass.data;
  }, //getPersonelPassportPdf
  async passportsPDF({ commit }, payload) {
    console.log(payload)
    await commit("clear_passportPDF");
    const pass = await HRPersonelRequestService.getPersonelPassportPdf(payload);
    await commit("set_passportPDF");
    return pass.data;
  },
  async getDistinctedPositions({ commit }, payload) {
    await commit("clear_distinctedPositions");
    const dist = await HRPersonelRequestService.getDistinctedPositions(payload);
    await commit("set_distinctedPositions");
    return dist.data;
  },

  async InsertOrUpdatePerson({ dispatch }, payload) {
    const insert = await HRPersonelRequestService.InsertOrUpdatePersonService(payload);
    dispatch("getAllAndGetByMail");
    return insert;
  },

  async addPermSelectedUser({ dispatch }, payload) {
    const perm = await HRPersonelRequestService.addPermSelectedUser(payload);
    dispatch("getUsersWithPerms");
    return perm;
  },

  async deletePermSelectedUser({ dispatch }, payload) {
    const perm = await HRPersonelRequestService.deletePermSelectedUser(payload);
    dispatch("getUsersWithPerms");
    return perm;
  },

  async getCvlTypes({ commit }) {
    await commit("clear_cvlTypes");
    const type = await HRPersonelRequestService.getCvlType();
    await commit("set_cvlTypes");
    return type.data;
  },

  async getCountries({ commit }) {
    await commit("clear_countries");
    const countries = await HRPersonelRequestService.getCountries();
    await commit("set_countries", countries);
    return countries.data;
  },


  async UploadMedicalCheckInformation({ dispatch }, payload) {
    const upload = await HRPersonelRequestService.UploadMedicalCheckInformationService(payload);
    dispatch("getAllAndGetByMail");
    return upload;
  },

  async UploadLicenceInformation({ dispatch }, payload) {
    const upload = await HRPersonelRequestService.UploadLicenceInformationService(payload);
    dispatch("getAllAndGetByMail");
    return upload;
  },

  async UploadPassaport({ dispatch }, payload) {
    const upload = await HRPersonelRequestService.UploadPassaportService(payload);
    dispatch("getAllAndGetByMail");
    return upload;
  },

  async UploadVisaInformation({ dispatch }, payload) {
    const upload = await HRPersonelRequestService.UploadVisaInformationService(payload);
    dispatch("getAllAndGetByMail");
    return upload;
  },

  async DeleteHRPersonel({ dispatch }, payload) {
    const person = await HRPersonelRequestService.DeleteHRPersonelService(payload);
    dispatch("getAllAndGetByMail");
    return person.data;
  },

  async DeleteDocumentAttachments({ dispatch }, payload) {
    const doc = await HRPersonelRequestService.DeleteDocumentAttachmentsService(payload);
    dispatch("getAllAndGetByMail");
    return doc.data;
  },

  async DeleteDocument({ dispatch }, payload) {
    const doc = await HRPersonelRequestService.DeleteDocumentService(payload);
    dispatch("getAllAndGetByMail");
    return doc.data;
  }

  // async HRPersonel({dispatch}, payload) {
  //     const hrPersonel = await HRPersonelRequestService.AddHRPersonel(payload);
  //     dispatch("getPersonList");
  //     return hrPersonel;
  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}